<template>
    <b-modal ref="zoomToOwnRangeModal" 
    centered 
    title="Przybliż do własnego zasięgu" 
    :visible="zoomToOwnRangeWindowVisible" 
    size="lg" 
    @shown="onShow" 
    @hidden="hide" 
    @ok="submit" 
    ok-title="Zatwierdź" 
    cancel-title="Anuluj">
      <b-container>
        <b-row>
          <b-col md="12">
            <b-alert show variant="info"><strong>Informacja.</strong> Funkcja pozwala na przybliżenie mapy do wskazanego zasięgu. <a href="/static/Szablon_wlasnego_zasiegu.csv" download>Pobierz szablon pliku</a>.</b-alert>
            <b-alert :show="alertFormContainsErrors" variant="danger">
              <strong>Uwaga.</strong> Formularz zawiera błędy.
            </b-alert>
            <b-alert :show="alertWrongSchema" variant="danger">
              <strong>Uwaga.</strong> Podany plik ma niepoprawny schemat.
            </b-alert>
            <b-alert :show="alertWrongCorners" variant="danger">
              <strong>Uwaga.</strong> Podane współrzędne lewego dolnego narożnika są większe od prawego górnego narożnika.
            </b-alert>
          </b-col>
        </b-row>
        <b-form>
          <b-row v-show="errors.rangeFileNotChoosen">
              <b-col offset-md="3" md="9">
                  <small class="text-danger">Należy wybrać plik.</small>
              </b-col>
          </b-row>
          <b-row v-show="errors.incorrectFileFormat">
              <b-col offset-md="3" md="9">
                  <small class="text-danger">Nieprawidłowy format pliku.</small>
              </b-col>
          </b-row>
          <b-form-row>
            <b-col md="12">
              <b-form-group :label-cols="3" breakpoint="md" label="Zasięg" label-for="range-file">
                  <b-form-file ref="fileinput" name="range-file" v-model="rangeFile" 
                    @change="fileChanged" 
                    :state="errors.rangeFileNotChoosen ? false : null" 
                    :accept="fileAccept"></b-form-file>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-container>
    </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { CoordinateSystems } from "../common/mapEnums";
import { WINDOW_ZOOM_TO_OWN_RANGE_HIDE } from "../store/mutations.type";

export default {
  name: "ZoomToOwnRangeWindow",
  data: function() {
    return {
      rangeFile: null,
      errors: {
        rangeFileNotChoosen: false,
        incorrectFileFormat: false
      },
      alertFormContainsErrors: false,
      alertWrongSchema: false,
      alertWrongCorners: false
    }
  },
  computed: {
    fileAccept() {
      return "text/csv, application/vnd.ms-excel, .csv";
    },
    ...mapGetters(["zoomToOwnRangeWindowVisible"])
  },
  methods: {
    onShow() {
      const vm = this;
      this.rangeFile = null;
      this.$refs.fileinput.reset();
      this.alertFormContainsErrors = false;
      this.alertWrongSchema = false;
      this.alertWrongCorners = false;
      Object.keys(this.errors).forEach(x => (vm.errors[x] = false));
    },
    hide() {
      this.$store.commit(WINDOW_ZOOM_TO_OWN_RANGE_HIDE);
    },
    submit(event) {
      event.preventDefault();

      const vm = this;
      this.alertFormContainsErrors = false;
      this.alertWrongSchema = false;
      this.alertWrongCorners = false;

      if (this.validate()) {
        let reader = new FileReader();
        reader.onload = function() {
          var lines = this.result.split('\n').filter(x => x.length !== 0);
          if (lines.length == 2) {
            let leftBottom = [];
            let rightTop = [];

            for (let i = 0; i < 2; ++i) {
              let values = lines[i].replace(/\s/g, "").replace(/"/g, "").split(',');
              if (values.length === 3){
                //Przypisanie odpowiednich wartości zamieniając kolejność koordynaty.
                switch(values[0]){
                  case 'LD':
                    leftBottom.push(parseFloat(values[2]));
                    leftBottom.push(parseFloat(values[1]));
                    break;
                  case 'PG':
                    rightTop.push(parseFloat(values[2]));
                    rightTop.push(parseFloat(values[1]));
                    break;
                }
              }
            }

            //Sprawdzenie, czy obie współrzędnę posiadają dwie numeryczne wartości, dla pierwszej w zakresie -90:90, a drugiej -180:180.
            if((leftBottom.length === 2 && rightTop.length === 2) && 
               (leftBottom.every(x => !isNaN(x)) && rightTop.every(x => !isNaN(x))) &&
               ((leftBottom[0] >= -90 && leftBottom[0] <= 90) && (leftBottom[1] >= -180 && leftBottom[1] <= 180)) &&
               ((rightTop[0] >= -90 && rightTop[0] <= 90) && (rightTop[1] >= -180 && rightTop[1] <= 180))) { 
                if(leftBottom[0] < rightTop[0] && leftBottom[1] < rightTop[1]) {
                  vm.$emit("set-range", {
                    leftBottom: leftBottom,
                    rightTop: rightTop,
                    coordinateSystem: CoordinateSystems.find(x => x.name === 'WGS84').epsg
                  });

                  vm.hide();
                  return false; 
                } else {
                  vm.alertWrongCorners = true;
                  return false;
                }
              }
            }

            vm.alertWrongSchema = true;
        }
        
        reader.onerror = function() {
          vm.alertWrongSchema = true;
        }

        reader.readAsText(this.rangeFile);
      } else {
        this.alertFormContainsErrors = true;
      }
    },
    validate() {
      const vm = this;
      Object.keys(this.errors).forEach(x => (vm.errors[x] = false));
      this.errors.rangeFileNotChoosen = false;

      if (this.rangeFile === null) {
        this.errors.rangeFileNotChoosen = true;
      } else if(!this.fileProperExtension(this.rangeFile)) {
        this.errors.incorrectFileFormat = true;
      }

      return !Object.keys(this.errors).some(x => vm.errors[x] === true);
    },
    fileChanged(event) {
      const files = event.target.files;
      if (files.length) {
        if (!this.fileProperExtension(files[0])) {
          this.errors.incorrectFileFormat = true;
        }
      } else {
        this.errors.incorrectFileFormat = false;
      }
    },
    fileProperExtension(file) {
      return /\.csv$/.test(file.name);
    }
  },
};
</script>